import React from 'react';
import styles from '../Navigation.less';
import AddressSearchAndBurgerMenu from './AddressSearchAndBurgerMenu';
import NewMapNavigationMenuMobile from "./NewMapNavigationMenuMobile";

const defaultView = () => (
  <>
    <AddressSearchAndBurgerMenu />
    <NewMapNavigationMenuMobile />
  </>
);

const NavigationSidebarMobile = ({ isNavigationHeaderFolded }) => {

  return (
    <div className={`grid padding-top-m ${isNavigationHeaderFolded ? styles.folded : ''}`}>
      <div className="grid">
        {defaultView()}
      </div>
    </div>
  );
};

export default NavigationSidebarMobile;
